<template>
    <div class="transportation">
        <el-row type="flex"
                class="row-bg"
                justify="center">
            <el-col :span="20">
                <el-col :span="24"
                        class="center">
                    <p class="head">{{articleContent.title}}</p>
                    <p class="text">{{articleContent.description}}</p>
                </el-col>
            </el-col>
        </el-row>
        <el-row type="flex"
                class="row-bg main"
                justify="center">
            <el-col :span="20">
                <div class="content"
                     v-html="articleContent.osArticleContent.content">
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
// import { queryproductdescbyid } from "@/api/productInfo";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            // articleContent: {
            //     title: "",
            //     description: "",
            //     osArticleContent: { content: "" }
        };
    },
    computed: {
        ...mapGetters(["activeIndex", "articleContent"])
    },
    mounted() {
        // if (this.$route.query.id) {
        //     this.$store.dispatch("ProductdescById", this.$route.query.id);
        // }
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.transportation {
    padding-bottom: 59px;
    background-color: #f5f6f7;
    .center {
        .head {
            margin-top: 60px;
            font-size: 20px;
            text-align: center;
        }
        .text {
            line-height: 22px;
            text-align: center;
            margin-top: 10px;
            color: #333;
            font-size: 14px;
        }
    }
    .main {
        margin-top: 30px;
        .el-col {
            background-color: #fff;
            .content {
                margin: 30px 60px;
                white-space: pre-line;
                word-wrap: break-word;
                word-break: break-all;
                /deep/ .el-table {
                    margin-top: 10px;
                    border: none;
                    /deep/ th {
                        background-color: #e2e2e2;
                        color: #221814;
                    }
                    /deep/ td {
                        border: none;
                        background-color: #f3f3f3;
                        border-bottom: 1px solid #fff;
                        color: #221814;
                    }
                }
                .el-table--group::after,
                .el-table--border::after,
                .el-table::before {
                    background-color: #fff;
                }
                p {
                    font-size: 14px;
                    color: #666;
                    margin-top: 5px;
                    line-height: 24px;
                }
                p:nth-child(1),
                p:nth-child(5),
                p:nth-child(12),
                p:nth-child(16),
                p:nth-child(26) {
                    font-size: 16px;
                    margin-top: 30px;
                    font-weight: 600;
                    color: #000;
                }
                p:nth-last-child(1) {
                    margin-bottom: 40px;
                }
                .totop {
                    margin-top: 4px;
                }
                span {
                    display: inline-block;
                    width: 36px;
                    height: 3px;
                    background-color: #fabe00;
                    position: relative;
                    top: -6px;
                }
            }
        }
    }
}
</style>
